import React from 'react'
import { useQuery } from '@apollo/client'
import ScheduleOnboarding from './schedule-onboarding'
import GET_COACH_ACCOUNT from '../query'
import LinearProgress from '@material-ui/core/LinearProgress'
import { PageHeader } from 'components/page-header'
import { useRouteMatch } from 'react-router-dom'

const ScheduleOnboardingPage = () => {
  const { data, loading } = useQuery(GET_COACH_ACCOUNT)
  const activeGroupEvents = data?.currentUser?.groupEvents.filter(
    e => !e.isCanceled,
  )

  const { path } = useRouteMatch()

  const crumbs = [
    {
      label: 'Home',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]

  const onboardingSchedule = {
    isFacilitiesCreated: data?.currentUser?.attributes?.facilities.length > 0,
    isGroupEventCreated: activeGroupEvents?.length > 0,
    isAvailable: data?.coachAvailabilities?.some(a => a.timeSlots.length > 0),
    isBookingTypeCreated: data?.lessonTypes.length > 0,
    hasCoachProfile: data?.currentUser?.attributes?.coachProfile !== null,
  }

  return (
    <>
      {loading && <LinearProgress color="primary" />}
      <PageHeader title="Set Up PGA Schedule" crumbs={crumbs} />
      <ScheduleOnboarding onboardingSchedule={onboardingSchedule} />
    </>
  )
}

export default ScheduleOnboardingPage
